import { ComponentsOverrides, Theme } from "@mui/material";

const MuiTableRow: ComponentsOverrides<Theme>["MuiTableRow"] = {
  root: {},
};

export default MuiTableRow;
